// ----------------------------------------
// Destinations
// ----------------------------------------
export const NAVIGATION_DESTINATIONS_LIMIT = 7;

// ----------------------------------------
// Journeys
// ----------------------------------------
/** Multi-Day Itineraries の最大表示件数 */
export const NAVIGATION_MULTI_DAY_LIMIT = 6;

/** Short-Stay で表示するエリアの定義 */
export const SHORT_STAY_AREAS = [
  { id: 'kyoto', label: 'Kyoto' },
  { id: 'tokyo', label: 'Tokyo' },
  { id: 'hakone', label: 'Hakone' },
  { id: 'kanazawa', label: 'Kanazawa' },
  { id: 'hidatakayama', label: 'Hida Takayama' },
  { id: 'setouchi', label: 'Setouchi' },
] as const;

export type ShortStayAreaId = (typeof SHORT_STAY_AREAS)[number]['id'];

/** Short-Stay エリアのリンク先ベースURL */
export const SHORT_STAY_BASE_URL = 'https://lp.wabunka-lux.jp/all-wabunka-journeys';

// ----------------------------------------
// Curated Stays
// ----------------------------------------
/** Curated Stays のテーマスラッグ */
export const CURATED_STAYS_THEME_SLUG = 'experiential-stays';

/** Curated Stays の View more リンク先 */
export const CURATED_STAYS_VIEW_MORE_URL = '/japan/experiential-stays/';

/** Curated Stays で除外するタググループ名 */
export const CURATED_STAYS_EXCLUDED_GROUPS = ['Most popular', 'Northern Japan', 'Okinawa'];

// ----------------------------------------
// Experiences
// ----------------------------------------
/** Experiences (Themes) の最大表示件数 */
export const NAVIGATION_THEMES_LIMIT = 10;

// ----------------------------------------
// Search Modal Tab Index
// ----------------------------------------
/** Search Experiences モーダルのタブインデックス */
export const SEARCH_TAB_INDEX = {
  DESTINATIONS: 0,
  DATES: 1,
  THEMES: 2,
  PREFERENCES: 3,
} as const;
